import Image from "next/image";
import React from "react";
//components
import ComparisonPageTestimonial from "@components/ComparisonPageV2/ComparisonPageTestimonial";
import FeaturesComparison, { ComparisonDataProps, HeaderDataProps } from "@components/ComparisonPageV2/FeaturesComparison";
import RatingComparison, { RatingComparisonDataProps, RatingHeaderDataProps } from "@components/ComparisonPageV2/RatingComparison";
import FeatureCard, { FeatureCardItemProps } from "@components/FeatureCardV2";
import PageMainTitleCard from "@components/LandingPageComponents/PageMainTitleCard";
import NewLayout from "@components/new-ui/Layout";
import YellowCTAhref from "@components/yellowCTAhref";
//Icons
import { BiConversation } from "react-icons/bi";
import { FaChartLine } from "react-icons/fa";
import { GrDirections } from "react-icons/gr";
import { HiOutlineTemplate } from "react-icons/hi";
import { IoPushOutline } from "react-icons/io5";
import { LuBot } from "react-icons/lu";
import { MdInstallDesktop, MdOutlineDashboardCustomize, MdOutlinePayments } from "react-icons/md";

import HeroButton from "@components/HeroButton";
import ClientLogos from "@components/new-ui/ClientLogos";

const headerStyle = "text-3xl font-bold text-gray-700";
const featureCardInput: FeatureCardItemProps[] = [
    {
        title: <h2 className={headerStyle}>Launch your first Chatbot within 30 seconds</h2>,
        meritsLists: [
            { icon: LuBot, listItem: "Eliminate complex steps and build a no-code chatbot" },
            { icon: HiOutlineTemplate, listItem: "Ready to integrate templates reduces the user effort" },
            {
                icon: IoPushOutline,
                listItem: "Within the bot you would be able to push to Google Sheets, trigger payments, push the data to CRM.",
            },
        ],
        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/best-rasayel-alternative/feature-card/chatbot.png",
        mediaAltText: "Build your Chatbot with No-Code",
        mediaPosition: "left",
    },
    {
        title: <h2 className={headerStyle}>Lower cost per acquisition using Click to WhatsApp Ads</h2>,
        meritsLists: [
            { icon: FaChartLine, listItem: "Measure your campaign performance inside Gallabox" },
            { icon: GrDirections, listItem: "Direct the conversation to bots to qualify leads" },
            {
                icon: BiConversation,
                listItem: "72 Hour Free Conversation Window : Send any type of message to the customer without incurring additional charges",
            },
        ],
        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/best-rasayel-alternative/feature-card/wa-ads.png",
        mediaAltText: "Click to WhatsApp Ads",
        mediaPosition: "right",
    },
    {
        title: <h2 className={headerStyle}>30+ Integrations, within your budget</h2>,
        meritsLists: [
            { icon: MdOutlineDashboardCustomize, listItem: "Asynchronously push your data to your CRM for a 360 view of the prospect." },
            { icon: MdInstallDesktop, listItem: "Setup Automations using Zapier, Pabbly based on specific event triggers" },
            { icon: MdOutlinePayments, listItem: "Automate and simplify payment collection on WhatsApp used our in-built payment gateway integrations." },
        ],
        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/best-rasayel-alternative/feature-card/wa-integration.png",
        mediaAltText: "Integrations with various business apps",
        mediaPosition: "left",
    },
];
const tableHeaderData: HeaderDataProps[] = [
    {
        title: "Features",
        isGallabox: false,
    },
    {
        title: <Image width={190} height={42} src="/comparison-page/gallabox-logo-fullwhite.png" alt="Gallabox Logo" />,
        isGallabox: true,
    },
    {
        title: <Image width={152} height={42} src="/comparison-page/rasayel-logo.png" alt="Rasayel Logo" />,
        isGallabox: false,
    },
];

const tableComparisonData: ComparisonDataProps[] = [
    { featureName: "Price", gallabox: "Starts from $89 for 3 Users", competitor: "Starts from $30 for 1 user" },
    { featureName: "Contact Import", gallabox: "Unlimited", competitor: "10K Per Import " },
    { featureName: "Integrations", gallabox: "40+ Integrations (Zoho, Odoo, Shopify….)", competitor: "Limited with Hubspot & Pipedrive" },
    { featureName: "Click to WhatsApp Ads", gallabox: "Measure campaign performance", competitor: "Not supported" },
    { featureName: "Reports", gallabox: "Advanced reports with bot & agent analytics", competitor: "Agent & Team Performance Report" },
    { featureName: "Chatbot", gallabox: "AI Chatbot ", competitor: "Rule based chatbot " },
];

const ratingHeaderData: RatingHeaderDataProps[] = [
    {
        title: (
            <div className="flex gap-2 items-center">
                <Image width={50} height={50} src="https://assets.gallabox.com/gb-home/new-wati/orange-logo.svg" alt="G2 Logo" />
                <p className="lg:text-3xl text-2xl lg:font-semibold font-medium text-gray-800">Ratings</p>
            </div>
        ),
    },
    {
        title: <Image width={176} height={37} src="/comparison-page/gallabox-logo.png" alt="Gallabox Logo" />,
    },
    {
        title: <Image width={142} height={40} src="/comparison-page/rasayel-logo.png" alt="Rasayel Logo" />,
    },
];
const ratingComparisonData: RatingComparisonDataProps[] = [
    {
        featureName: "Meets Requirements",
        gallabox: 9.0,
        competitor: 9.0,
    },
    {
        featureName: "Ease of Use",
        gallabox: 9.1,
        competitor: 8.7,
    },
    {
        featureName: "Quality of Support",
        gallabox: 9.0,
        competitor: 9.0,
    },
];

const RasayelLandingPage: React.FC = () => {
    return (
        <NewLayout
            title="Best Rasayel Alternative in 2024 - Compare Gallabox and Rasayel"
            description="Gallabox is a cost-effective solution to your WhatsApp marketing needs with capabilities like ctwa & drip marketing  makes it the #1 Rasayel alternative"
            canonical="https://gallabox.com/best-rasayel-alternative"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/best-rasayel-alternative/og.png" }}
            keywords="Best Alternative to Rasayel"
        >
            <PageMainTitleCard
                chipTitle="Best Alternative to Rasayel"
                mainTitle={
                    <h1 className="lg:text-6xl text-4xl font-bold text-gray-700 text-left">
                        No more complex chatbot setup! <br />
                        <span
                            className="text-transparent whitespace-nowrap"
                            style={{ background: "linear-gradient(92deg, #1E3B94 6.44%, #3364FA 76.74%)", backgroundClip: "text" }}
                        >
                            Switch to Gallabox
                        </span>
                    </h1>
                }
                description={
                    <p className="lg:py-6 py-4 text-base font-normal text-center lg:text-left text-gray-500">
                        Ensure a smooth transition with dedicated account support for migration, contacts, and training.
                    </p>
                }
                primaryButton={<HeroButton buttontext="7-day free trial" />}
                mediaType="image"
                mediaUrl="https://assets.gallabox.com/gb-home/best-rasayel-alternative/rasayel-header-1.gif"
                mediaAltText="No more complex chatbot setup! Switch to Gallabox"
                showKeyFeatures={false}
            />

            <div className="lg:max-w-7xl mx-auto lg:pt-0 lg:pb-10 py-14">
                <h2 className="text-base text-center font-normal py-2">
                    <span className="font-bold">10,000+ Customers </span>Who Get More Out of Their Broadcasts{" "}
                </h2>
                <ClientLogos />
            </div>
            <section className="lg:my-20 my-10">
                <ComparisonPageTestimonial
                    mainTitle="Testimonials"
                    quotationText='"Gallabox An Amazing Tool for Easy Bot Building"'
                    question="What do you like best about Gallabox?"
                    description="The Gallabox Whatsapp Chatbot builder is incredibly user-friendly and easy to use. It allowed us to create a custom chatbot in just a few minutes, which
                        helped our customers to communicate with the bot directly. We used the solution to answer customer queries, provide support, and generated leads. We
                        were seriously impressed by the support provided by the Gallabox Team. with a comprehensive knowledge base and an experienced team of professionals
                        available to help. The team also provided technical support. Overall, Gallabox is a fantastic tool for businesses looking to solve business
                        communication/marketing problems. It is user-friendly, easy to use, and provides fantastic support."
                    founderName="Manmeet Kalra"
                    companyName="Founder - Zeigen"
                    starFill={["full", "full", "full", "full", "half"]}
                />
            </section>
            <FeaturesComparison mainTitle="Save time, cost and avoid hidden problems by switching to Gallabox" headerData={tableHeaderData} comparisonData={tableComparisonData} />

            <FeatureCard mobileView="content-first" cardData={featureCardInput} />

            <section className="lg:max-w-4xl lg:mx-auto lg:my-20 my-10 w-fit mx-2">
                <div className="flex flex-col gap-6 mb-6">
                    <h2 className="lg:text-3xl text-2xl font-semibold max-w-4xl mx-auto w-full text-center px-2 text-gray-700">
                        Track, Analyze and <span className="text-green-500"> Measure Success</span> with Dashboard
                    </h2>

                    <p className="text-base text-center text-gray-600">
                        Our intuitive Gallabox dashboard helps you uncover valuable trends and optimize your chatbot&apos;s <br /> performance for better customer engagement.
                    </p>
                </div>
                <div
                    className="flex items-center justify-center rounded-xl lg:p-10 px-0 py-10"
                    style={{
                        border: "2px solid white",
                        background: "linear-gradient(180deg, #EBF3FF 0%, #FFF 100%)",
                        boxShadow: "0px 0px 32px 0px rgba(108, 142, 181, 0.50), 0px 30px 50px 0px rgba(108, 142, 181, 0.25)",
                        backdropFilter: "blur(5.900000095367432px)",
                    }}
                >
                    <Image
                        width={790}
                        height={446}
                        src="https://assets.gallabox.com/gb-home/best-rasayel-alternative/performance.gif"
                        alt="Gallabox Dashboard: Unleash Your Chatbot's Potential"
                    />
                </div>
            </section>
            <section className="lg:my-20 mt-20 mb-10 lg:max-w-5xl lg:mx-auto w-full">
                <RatingComparison headerData={ratingHeaderData} comparisonData={ratingComparisonData} />
            </section>
            <section className="lg:my-20 mt-0 mb-10">
                <YellowCTAhref customText={<h3 className="text-3xl font-normal mb-4 text-yellow-800">Move from complex to simple WhatsApp Chatbot</h3>} />
            </section>
        </NewLayout>
    );
};

export default RasayelLandingPage;
